var _style, _path, _defs, _mask, _path2, _g, _g2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPl3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 503.4 170",
    style: {
      enableBackground: "new 0 0 503.4 170"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n\t.st1{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st2{mask:url(#mask0_1_);}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{opacity:0.2;}\r\n\t.st5{opacity:0.18;}\r\n\t.st6{fill:url(#SVGID_2_);}\r\n\t.st7{fill:url(#SVGID_3_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.1,92.1v23.5h-7.3V53.4h17.1c6.6,0,11.8,1.6,15.4,4.9c3.6,3.2,5.5,7.8,5.5,13.7s-2,10.7-6.1,14.5 c-4.1,3.8-9.5,5.6-16.4,5.6L191.1,92.1L191.1,92.1z M191.1,60v25.5h7.6c5,0,8.9-1.1,11.5-3.4c2.6-2.3,4-5.5,4-9.7 c0-8.2-4.8-12.3-14.6-12.3H191.1z M249,116.6c-6.6,0-11.8-2.1-15.7-6.2s-5.9-9.6-5.9-16.5c0-7.5,2-13.3,6.1-17.5s9.5-6.3,16.5-6.3 c6.6,0,11.8,2,15.5,6.1s5.6,9.7,5.6,16.9c0,7.1-2,12.7-6,17C261,114.4,255.6,116.5,249,116.6L249,116.6z M249.5,76.1 c-4.6,0-8.2,1.6-10.8,4.7s-4,7.4-4,12.8c0,5.3,1.3,9.4,4,12.4c2.6,3,6.3,4.6,10.8,4.6c4.6,0,8.1-1.5,10.6-4.5s3.7-7.2,3.7-12.7 c0-5.5-1.2-9.8-3.7-12.8C257.6,77.6,254,76.1,249.5,76.1L249.5,76.1z M337.1,71.2l-13.3,44.4h-7.4l-9.1-31.8 c-0.3-1.2-0.6-2.6-0.7-4.1h-0.2c-0.2,1.4-0.5,2.7-0.9,4l-9.9,31.8h-7.1L275,71.1h7.5l9.2,33.4c0.3,1,0.5,2.3,0.6,4h0.3 c0.1-1.4,0.4-2.7,0.8-4.1l10.2-33.3h6.5l9.2,33.4c0.3,1.1,0.5,2.4,0.6,4h0.3c0.1-1.1,0.3-2.5,0.7-4l9-33.4h7L337.1,71.2z  M379.7,95.1h-31.4c0.1,4.9,1.5,8.8,4,11.4c2.5,2.7,6,4,10.4,4c5,0,9.6-1.6,13.8-4.9v6.7c-3.9,2.8-9.1,4.2-15.5,4.2 c-6.3,0-11.2-2-14.8-6s-5.4-9.7-5.4-17c0-7,2-12.5,5.9-16.9c3.9-4.3,8.8-6.5,14.6-6.5s10.3,1.9,13.5,5.6c3.2,3.8,4.8,9,4.8,15.6v3.7 L379.7,95.1z M372.4,89.1c0-4.1-1-7.3-3-9.6s-4.7-3.5-8.1-3.5c-3.2-0.1-6.3,1.2-8.5,3.6c-2.3,2.4-3.8,5.5-4.3,9.4L372.4,89.1z  M413.1,78.4c-1.2-1-3-1.4-5.4-1.4c-3,0-5.6,1.4-7.6,4.3s-3.1,6.8-3.1,11.7v22.6H390V71.2h7.1v9.1h0.2c1-3.1,2.6-5.5,4.6-7.3 c2.1-1.8,4.4-2.6,7-2.6c1.8,0,3.3,0.2,4.2,0.6L413.1,78.4L413.1,78.4z M446.1,115.5V53.4h17.7c5.4,0,9.6,1.3,12.8,3.9 c3.1,2.6,4.7,6.1,4.7,10.3c0,3.5-1,6.6-2.9,9.2s-4.5,4.4-7.9,5.5v0.2c4.2,0.5,7.5,2.1,10,4.7c2.5,2.7,3.8,6.1,3.8,10.4 c0,5.3-1.9,9.6-5.7,12.9c-3.8,3.3-8.6,4.9-14.4,4.9C464.2,115.5,446.1,115.5,446.1,115.5z M453.4,60v20h7.5c4,0,7.1-1,9.4-2.9 c2.3-1.9,3.5-4.6,3.5-8.1c0-6-4-9.1-11.9-9.1L453.4,60z M453.4,86.6V109h9.9c4.3,0,7.6-1,9.9-3c2.4-2,3.5-4.8,3.5-8.3 c0-7.3-5-11-15-11L453.4,86.6z M503.4,115.5h-7.3V53.4h7.3V115.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 127.4,
    height: 173.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 127.4,
    height: 173.4,
    id: "mask0_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.8,7.1c0-3.9,3.2-7.1,7.1-7.1h42.5c3.9,0,7.1,3.2,7.1,7.1v155.7c0,3.9-3.2,7.1-7.1,7.1H7.1 c-3.9,0-7.1-3.2-7.1-7.1V92c0-3.9,3.2-7.1,7.1-7.1h28.3V49.5c0-3.9,3.2-7.1,7.1-7.1h28.3V7.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.4339,
    y1: 171.1044,
    x2: 134.0917,
    y2: 12.8554,
    gradientTransform: "matrix(1 0 0 -1 0 172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6AD10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C87E0E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.4,0v169.8H70.8V0H127.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92,50.2v120.3H35.4V43.2h49.5C88.8,43.2,92,46.3,92,50.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92,53.1v120.3H35.4V46h49.5C88.8,46,92,49.2,92,53.1z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.7117,
    y1: 127.13,
    x2: 93.498,
    y2: 5.3627,
    gradientTransform: "matrix(1 0 0 -1 0 172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6D751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6AD10"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M92,49.5v120.3H35.4V42.5h49.5C88.8,42.5,92,45.6,92,49.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.8106,
    y1: 90.374,
    x2: 42.5062,
    y2: 8.146,
    gradientTransform: "matrix(1 0 0 -1 0 172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E589"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6D751"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M0,84.9v84.9h56.6V92c0-3.9-3.2-7.1-7.1-7.1H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl3);
export default __webpack_public_path__ + "static/media/pl3.5206044c1b560bb32c1975023a3aa411.svg";
export { ForwardRef as ReactComponent };